import { useModelShowContext } from '@rhino-project/core/hooks';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { ModelBreadcrumb, ModelBreadcrumbProps } from './ModelBreadcrumb';
import { RhinoRecord } from '@rhino-project/core';

export type ModelShowHeaderProps = ModelBreadcrumbProps;

export const ModelShowHeaderBase = (props: ModelShowHeaderProps) => {
  const { resource } = useModelShowContext() as { resource: RhinoRecord };

  return <ModelBreadcrumb resource={resource} {...props} />;
};

export const ModelShowHeader = (props: ModelShowHeaderProps) =>
  useGlobalComponentForModel('ModelShowHeader', ModelShowHeaderBase, props);
